import { createReducer, on } from '@ngrx/store';
import { addItem, updateItem, getAllItems, deleteItem } from '../actions/app.actions';
import { User } from 'src/app/shared/models/user.model';
export const initialState = [new User('Johan', 'Zapata')];
const ɵ0 = (state, { name, last_name }) => [...state, new User(name, last_name)], ɵ1 = (state, { user }) => state.map(users => {
    if (users.id != user.id) {
        return user;
    }
    else {
        return users;
    }
}), ɵ2 = (state) => state, ɵ3 = (state, { id }) => state.filter(user => user.id != id);
const _appReducer = createReducer(initialState, on(addItem, ɵ0), on(updateItem, ɵ1), on(getAllItems, ɵ2), on(deleteItem, ɵ3));
export function appReducer(state, action) {
    return _appReducer(state, action);
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
